import type { VendorContactWhisper as VendorContactWhisperData } from '@frontend/api-types';
import { formatMinutes } from '@frontend/duck-tape';
import { Text } from '@frontend/web-react';

export type VendorContactPhoneWhisperProps = {
  whisper: VendorContactWhisperData;
};

export const VendorContactPhoneWhisper = ({ whisper }: VendorContactPhoneWhisperProps) => {
  const { durationSec, holdDurationSec } = whisper;
  const summary = [
    durationSec !== undefined ? formatMinutes(durationSec) : '',
    holdDurationSec !== undefined ? `${formatMinutes(holdDurationSec)} on hold` : '',
  ]
    .filter(Boolean)
    .join(' · ');
  if (!summary) return null;
  return (
    // eslint-disable-next-line tailwindcss/no-arbitrary-value
    <Text className="text-[11px] text-neutral-700" type="p-sm">
      {summary}
    </Text>
  );
};
